import ErrorBoundary from 'components/error-boundaries';
import Overview from 'modules/marketplace-performance-page/components/overview';
import Positions from 'modules/marketplace-performance-page/components/positions';
import MainPerformance from 'modules/marketplace-performance-page/components/main-performance';
import classNames from 'classnames';
import { useQueryParams } from 'modules/routing/useQueryParams';
import { useSchema } from 'modules/marketplace-performance-page/components/useSchema';
import { Tab } from 'modules/shared-components/tabs/tab';
import { StrategyPerformance } from 'api/types/httpsTypes/marketplace-performance';

const tabs = ['Main', 'Overview', 'Positions'];

const Stats = ({
  monthlyReturns,
  mainPerformance,
  stats,
  positions,
}: StrategyPerformance) => {
  const [queryParams, setQueryParams] = useQueryParams(useSchema());

  return (
    <ErrorBoundary>
      <div className="w-full lg:w-3/5 xl:w-3/4 ">
        <div className="bg-white-100 dark:bg-black-800 rounded-md shadow-md h-full">
          <ul className="list-none flex flex-wrap bg-white-300 dark:bg-black-700 xxs:rounded-t-md xxs:p-1 mb-0 text-lg border-bottom-new xxs:border-b-1 xxs:border-black-50 dark:border-black-400">
            {tabs.map((tab) => (
              <li
                key={tab}
                className={classNames(tab === 'Main' && 'lg:hidden')}
              >
                <Tab
                  tabName={tab}
                  active={tab === queryParams?.activeTab}
                  onClick={() =>
                    queryParams.activeTab !== 'Positions'
                      ? setQueryParams({
                          positionsActiveTab: 'Open',
                          activeTab: tab,
                        })
                      : setQueryParams({
                          positionsActiveTab: undefined,
                          activeTab: tab,
                        })
                  }
                />
              </li>
            ))}
          </ul>
          <div className="xxs:p-4">
            {queryParams.activeTab === 'Overview' && (
              <Overview stats={stats} monthlyReturns={monthlyReturns} />
            )}
            {queryParams.activeTab === 'Positions' && positions && (
              <Positions
                openPositionsStats={positions.open}
                closedPositionsStats={positions?.closed}
              />
            )}
            {queryParams.activeTab === 'Main' && (
              <MainPerformance mainPerformance={mainPerformance} />
            )}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};
export default Stats;
